<p-drawer
    [open]="errorMessages.showMessage()"
    (closed)="closeCallback()"
    [closeOnBackdrop]="true"
    [showClose]="false"
    position="right"
    size="sm">

    <div class="flex flex-col h-full">

        <!-- HEADER -->
        <div class="flex justify-between py-2 px-3">
            <label class="font-bold">{{ 'validation.validationErrors' | translate }}</label>

            <button (click)="closeCallback()" class="cursor-pointer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9.17188 14.8299L14.8319 9.16992" stroke="currentColor" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.8319 14.8299L9.17188 9.16992" stroke="currentColor" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round" />
                </svg>

            </button>
        </div>

        <div class="p-4 h-full overflow-auto [&::-webkit-scrollbar]:hidden">
            <div class="flex flex-col space-y-3">
                @for (message of errorMessages.messages(); track message) {
                    <div class="rounded-md px-3 py-2 text-sm"
                         [class.bg-red-100]="message.severity === 'error'" [class.text-red-700]="message.severity === 'error'"
                         [class.bg-yellow-100]="message.severity === 'warn'" [class.text-yellow-700]="message.severity === 'warn'"
                         [class.bg-blue-100]="message.severity === 'info'" [class.text-blue-700]="message.severity === 'info'"
                         [class.bg-green-100]="message.severity === 'success'" [class.text-green-700]="message.severity === 'success'">
                        {{ message.text }}
                    </div>
                }
            </div>
        </div>
    </div>
</p-drawer>
